import { useGetAllResources, useGetMyLibraryResources } from '_api';
import { useMemo } from 'react';

const useResources = ({
  page = 0,
  size = 1000,
}: { page?: number; size?: number } = {}) => {
  const { data: allResources, isFetching: isLoadingResources } = useGetAllResources({
    page,
    size,
  });

  const { data: myLibraryResources, isFetching: isLoading } = useGetMyLibraryResources({
    page,
    size,
  });

  const resourceOptions = useMemo(
    () =>
      allResources && myLibraryResources
        ? [...allResources, ...myLibraryResources].map((resource) => ({
            name: resource.id.toString(),
            description: resource.title,
          }))
        : [],
    [allResources],
  );

  return {
    allResources,
    resourceOptions,
    isLoading,
    isLoadingResources,
  };
};

export default useResources;
